<section class="briefing" [attr.data-posture]="home.posture()">
  <div class="briefing-glow" aria-hidden="true"></div>

  <div class="briefing-inner d-flex align-items-center">
    <div class="briefing-text d-flex flex-column min-w-0">
      <span class="briefing-date">{{ today() }}</span>

      <h1 class="briefing-greeting">{{ greetingKey() | translate: { name: firstName() } }}</h1>

      <p class="briefing-posture">
        @if (home.isAccountLoading()) {
        <span class="posture-detail">{{ 'app.home.briefing.posture_pending' | translate }}</span>
        } @else if (home.hasAccountError()) {
        <span class="posture-detail">{{ 'app.home.briefing.posture_unavailable' | translate }}</span>
        } @else {
        <span class="posture-dot" aria-hidden="true"></span>
        <span class="posture-title">{{ postureKey() | translate }}</span>
        <span class="posture-detail">{{ postureDetailKey() | translate: postureParams() }}</span>
        }
      </p>

      @if (refreshedLabel().length > 0) {
      <div class="briefing-meta d-flex align-items-center">
        <span>{{ 'app.home.briefing.updated_at' | translate: { time: refreshedLabel() } }}</span>
        <button type="button" mat-icon-button class="refresh-button" [disabled]="home.isAccountLoading()"
          [matTooltip]="'shared.general.tooltips.refresh' | translate" (click)="onRefresh()">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
      }
    </div>

    @if (hasScore()) {
    <div class="briefing-score d-flex flex-column align-items-center ms-auto flex-shrink-0">
      <svg class="score-ring" viewBox="0 0 120 120" role="img"
        [attr.aria-label]="'app.home.briefing.score_label' | translate: { score: scoreLabel() }">
        <circle class="ring-track" cx="60" cy="60" [attr.r]="ringRadius" />
        <circle class="ring-value" cx="60" cy="60" [attr.r]="ringRadius"
          [attr.stroke-dasharray]="ringCircumference" [attr.stroke-dashoffset]="ringOffset()" />
      </svg>

      <div class="score-readout d-flex flex-column align-items-center">
        <span class="score-value">{{ scoreLabel() }}</span>
        <span class="score-caption">{{ 'app.home.briefing.score_caption' | translate }}</span>
      </div>
    </div>
    } @else if (home.isFleetScanning()) {
    <div class="briefing-score-placeholder ms-auto flex-shrink-0 d-flex align-items-center justify-content-center">
      <mat-progress-spinner mode="indeterminate" diameter="40" />
    </div>
    }
  </div>
</section>
